export default {"src":"/_next/static/media/houses-icon.2dc93b07.svg","height":81,"width":94,"blurWidth":0,"blurHeight":0};